import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from './core/auth/roles';
import { canActivateAuth } from './core/guards/auth.guard';
import { canActivateRole } from './core/guards/role.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { NotFoundComponent } from './views/not-found/not-found.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./features/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'app',
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/app-shell/app-shell.module').then(
                (m) => m.AppShellModule
            ),
    },
    {
        path: 'onboarding',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/onboarding/onboarding.module').then(
                (m) => m.OnboardingModule
            ),
    },
    {
        path: 'desconto',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/discount/discount.module').then(
                (m) => m.DiscountModule
            ),
    },
    {
        path: 'reports',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/reports/reports.module').then(
                (m) => m.ReportsModule
            ),
    },
    {
        path: 'feature-parameters',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth, canActivateRole(Role.CustodiaDev)],
        loadChildren: () =>
            import('./features/feature-flags/feature-flags.module').then(
                (m) => m.FeatureFlagsModule
            ),
    },
    {
        path: 'ciclo-cobranca',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/billing-cycle/billing-cycle.module').then(
                (m) => m.BillingCycleModule
            ),
    },
    {
        path: 'retry-relatorio',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/retry-relatorio/retry-relatorio.module').then(
                (m) => m.RetryRelatorioModule
            ),
    },
    {
        path: 'reenvio-relatorio-corrigido',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth, canActivateRole(Role.CustodiaDev)],
        loadChildren: () =>
            import(
                './features/monthly-report-correction/monthly-report-correction.module'
            ).then((m) => m.MonthlyReportCorrectionModule),
    },
    {
        path: 'disparar-cobranca',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth, canActivateRole(Role.CustodiaDev)],
        loadChildren: () =>
            import('./features/run-billing-job/run-billing-job.module').then(
                (m) => m.RunBillingJobModule
            ),
    },
    {
        path: 'processamento-cobranca',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import(
                './features/billing-processing/billing-processing.module'
            ).then((m) => m.BillingProcessingModule),
    },
    {
        path: 'ajustar-cashback',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/adjust-cashback/adjust-cashback.module').then(
                (m) => m.AdjustCashbackModule
            ),
    },
    {
        path: 'bloqueio-cobranca',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import(
                './features/billing-blocklist/billing-blocklist.module'
            ).then((m) => m.BillingBlocklistModule),
    },
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
